import { isServer, MutationCache, QueryCache, QueryClient } from "@tanstack/react-query"

import { recoverFromServerActionDeploymentMismatch } from "@/lib/client/deployment-recovery"

function makeQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: recoverFromServerActionDeploymentMismatch,
    }),
    mutationCache: new MutationCache({
      onError: recoverFromServerActionDeploymentMismatch,
    }),
    defaultOptions: {
      queries: {
        retry: false,
        staleTime: 60 * 1000,
      },
    },
  })
}

let browserQueryClient: QueryClient | undefined

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient()
  }

  if (!browserQueryClient) {
    browserQueryClient = makeQueryClient()
  }

  return browserQueryClient
}
